import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';


export const uMUsersApi = createApi({
  reducerPath: 'uMUsersApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['users','groups','permissions'],
  endpoints: builder => ({
    // Retrieve or filter users
    getUsers: builder.query({
      query: (params) => ({
        url: '/users/',
        params,
      }),
      providesTags:['users']
    }),
    // Create a new user
    createUser: builder.mutation({
      query: (userData) => ({
        url: '/users/',
        method: 'POST',
        body: userData,
      }),
      invalidatesTags:['users']
    }),
    // Retrieve a specific user by ID
    getUserById: builder.query({
      query: (id) => ({
        url: `/users/${id}/`,
        method: 'GET',
      }),
    }),
    // Update a specific user's data (excluding password)
    updateUser: builder.mutation({
      query: ({ id, body }) => ({
        url: `/users/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags:['users']
    }),
    // Delete a user by ID
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `/users/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags:['users']
    }),
    // User login
    loginUser: builder.mutation({
      query: (loginData) => ({
        url: '/users/login/',
        method: 'POST',
        body: loginData,
      }),
    }),
    // Change user password
    changePassword: builder.mutation({
      query: (passwordData) => ({
        url: '/users/reset-password/',
        method: 'POST',
        body: passwordData,
      }),
    }),
    //get groups
    getGroups: builder.query({
      query: (filters) => ({
        url: '/users/groups/',
        method: 'GET',
        params: filters,
      }),
      providesTags:['groups']
    }),
    // Create a new Group
    createGroup: builder.mutation({
      query: (userData) => ({
        url: '/users/groups/',
        method: 'POST',
        body: userData,
      }),
      invalidatesTags:['groups']
    }),
    // Retrieve a specific Group by ID
    getGroupById: builder.query({
      query: (id) => ({
        url: `/users/groups/${id}/`,
        method: 'GET',
      }),
    }),
    // Update a specific Group
    updateGroup: builder.mutation({
      query: ({ id, body }) => ({
        url: `/users/groups/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags:['groups']
    }),
    // Delete a Group by ID
    deleteGroup: builder.mutation({
      query: (id) => ({
        url: `/users/groups/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags:['groups']
    }),

    //get Permission
    getPermissions: builder.query({
      query: (filters) => ({
        url: '/users/permissions/',
        method: 'GET',
        params: filters,
      }),
      providesTags:['permissions']
    }),
    // Create a new Permission
    createPermission: builder.mutation({
      query: (userData) => ({
        url: '/users/permissions/',
        method: 'POST',
        body: userData,
      }),
      invalidatesTags:['permissions']
    }),
    // Retrieve a specific Permission by ID
    getPermissionById: builder.query({
      query: (id) => ({
        url: `/users/permissions/${id}/`,
        method: 'GET',
      }),
    }),
    // Update a specific Permission
    updatePermission: builder.mutation({
      query: ({ id, body }) => ({
        url: `/users/permissions/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags:['permissions']
    }),
    // Delete a Permission by ID
    deletePermission: builder.mutation({
      query: (id) => ({
        url: `/users/permissions/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags:['permissions']
    }),
  }),
});

export const {
  useGetUsersQuery,
  useLazyGetUsersQuery,
  useCreateUserMutation,
  useGetUserByIdQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useLoginUserMutation,
  useChangePasswordMutation,
  useGetGroupsQuery,
  useLazyGetGroupsQuery,
  useCreateGroupMutation,
  useGetGroupByIdQuery,
  useUpdateGroupMutation,
  useDeleteGroupMutation,
  useGetPermissionsQuery,
  useLazyGetPermissionsQuery,
  useCreatePermissionMutation,
  useGetPermissionByIdQuery,
  useUpdatePermissionMutation,
  useDeletePermissionMutation,
} = uMUsersApi;
